<template>
    <div id="entranceWap" :class="{ 'entranceWap_Back': currentTime > changeTime }">
        <div class="entranceWap-comment">
            <span class="tit" :class="{ 'titBack': currentTime > changeTime }" @click.self="toCommentReport"></span>
        </div>
    </div>

</template>
<script>
var _bdhmProtocol = (("https:" == document.location.protocol) ? " https://" : " //");
document.write(unescape("%3Cscript src='" + _bdhmProtocol + "hm.baidu.com/h.js%3Fdcb5060fba0123ff56d253331f28db6a' %3E%3C/script%3E"));
</script>
<script>

export default {
    name: 'entranceWap',
    data() {
        return {
            weiboDownloadUrl: 'https://app.gamersky.com/toapp/?url=%2322YR_WeiBo&iOSUMKey=9LTrme&androidUMKey=jeGb4r',
            gongzhonghaoDownloadUrl: 'https://app.gamersky.com/toapp/?url=%2322YR_GZH&iOSUMKey=991D8n&androidUMKey=CmOHXD',
            changeTime: new Date('2023/01/10 10:00:00').getTime(),
            currentTime: new Date().getTime(),
        }
    },
    created() {
        // 友盟统计
        GSAppJsApi.UMeng.recordEvent('enter_wap_guidepage', 0);
        // 事件统计
        GSAppJsApi.EventStatistics.recordEvent('B19109_wap引导页进入人数', {}, 0);
    },

    methods: {
        toCommentReport() {
            let qudao = this.$utils.urlParam(window.location.href, 'qudao');
            let url = this.weiboDownloadUrl;
            if (qudao == 'gongzhonghao') {
                url = this.gongzhonghaoDownloadUrl;
            }
            let a = document.createElement("a");
            a.href = url;
            a.target = 'blank';
            a.click();
            a.remove();
        },
    }
}
</script>

<style>
body {
    background: #DB5353;
}


#entranceWap {
    width: 100%;
    min-height: 42.2rem;
    overflow: hidden;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/wapbg.png') no-repeat;
    background-size: 100%;
}

.entranceWap_Back {
    width: 100%;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/wapbg_Back.png') no-repeat top center / 100% auto !important;
}

.entranceWap_Back::before{
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #DB5353;
    z-index: -1;
}

.entranceWap-comment {
    position: fixed;
    left: 50%;
    margin-left: -146px;
    bottom: 78px;
    display: flex;
    justify-content: center;
}

.entranceWap-comment .tit {
    width: 293px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/wapBtn.png') no-repeat center;
    background-size: 100% auto;
}

.entranceWap-comment .titBack {
    width: 293px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background: url('https://image.gamersky.com/webimg13/zt/22annual/wapBtn_Back.png') no-repeat center;
    background-size: 100% auto;
}
</style>